import { ReactComponent as BackIcon } from 'assets/icons/eiq-connect/back.svg';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface BottomHeaderProps {
  title: string;
  showBackText?: boolean;
  defaultBackRoute?: string;
}

const BottomHeader: React.FC<BottomHeaderProps> = ({ title, showBackText = true, defaultBackRoute = '/eiq-connect/guests' }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    const canGoBack = (window.history.state?.idx ?? 0) > 0;

    if (canGoBack) {
      navigate(-1);
    } else {
      navigate(defaultBackRoute, { replace: true });
    }
  };

  return (
    <div className="eiq-bottom-header">
      <span className="eiq-back-btn" onClick={handleBack}>
        <BackIcon />
        {showBackText && 'Back'}
      </span>
      <h1 className="eiq-title">{title}</h1>
    </div>
  );
};

export default BottomHeader;
